import { defineComponent as _defineComponent } from 'vue';
import { trans } from 'laravel-vue-i18n';
import { DateTime } from 'luxon';
import Chip from 'primevue/chip';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PhenologicalPhaseBadge',
    props: {
        phenologicalPhaseCrop: {
            type: Object,
            required: true,
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const label = computed(() => {
            const { code } = props.phenologicalPhaseCrop.phenological_phase;
            const phenologicalPhaseName = trans(`phenological_phases.${code}`);
            const startDate = DateTime.fromISO(props.phenologicalPhaseCrop.start_date).toFormat('dd/MM/yyyy');
            const endDate = DateTime.fromISO(props.phenologicalPhaseCrop.end_date).toFormat('dd/MM/yyyy');
            return `FASE FENOLOGICA ATTUALE: ${phenologicalPhaseName.toUpperCase()} (${startDate} - ${endDate})`;
        });
        const __returned__ = { props, label, get Chip() { return Chip; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
